import { replaceQueryParam } from "./replace-query-param.js";
const replaceQueryParams = (paramSets, search) => {
  return paramSets.reduce((prev, { name, newValue }) => {
    return replaceQueryParam({ name, newValue }, prev);
  }, search);
};
export {
  replaceQueryParams
};
//# sourceMappingURL=replace-query-params.js.map
